import React from "react";
import Applet from "../../Applet";
// THE DEFAULT EXPORT, which is withBreakpoint(withAppContext(PlatformTable)). The named export is
// the bare class: it reads this.props.appContext.sessionContext in componentDidMount, so rendering
// it unwrapped dies there on "Cannot read properties of undefined".
import PlatformTable from "../../../../components/PlatformTable";

/**
 * The grid inside the "choose an object" dialog.
 *
 * IDENTIFIER, NAME, KIND, STATE -- the four things that tell two similarly-named records apart.
 * Search is on, because the point of a long list is that scrolling it is not an option: a realm
 * holds hundreds of objects and the reader knows roughly what they are looking for.
 *
 * EVERY CLASSIFICATION, deliberately. An edge may span them -- a Contract to a Supplier -- so
 * filtering this to the page's own kind would refuse exactly the relationships worth recording.
 */
class RelatableObjectTableApplet extends Applet {

    render() {
        return <PlatformTable applet={this}
                              pageSize={this.state.PageSize}
                              placement={this.state.Placement}
                              columns={this.state.Columns}
                              title="Objects"
                              enterpriseComponent={this.getEnterpriseComponent()}
                              sort={this.state.Sort}
                              menu={this.state.Menu}
                              rowHeight={this.state.RowHeight}
                              enableSearch={true}
                              enableSort={true}
        />;
    }

    state = {
        Name: "RelatableObjectTableApplet",
        Menu: {options: [{displayValue: "Refresh", value: "Refresh"}]},
        RowHeight: 44,
        PageSize: {"default": 10, "xs": 3, "sm": 3, "md": 10, "lg": 10, "lx": 10},
        Placement: {
            "xl": [{id: "ObjectID"}, {id: "Name"}, {id: "ObjectClassification"}, {id: "Status"}],
        },
        Columns: [
            {id: "ObjectID", width: 140, cellRenderer: "Standard Single Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Object ID", hideable: false},
            {id: "Name", width: 380, cellRenderer: "Standard Single Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Name", hideable: false},
            {id: "ObjectClassification", width: 150, cellRenderer: "Standard Single Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Type", hideable: false},
            {id: "Status", width: 130, cellRenderer: "Standard Single Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Status"},
        ],
        Sort: [{
            "Identifier": "Name",
            "Visible": true,
            "Default": true,
            "Options": [{"Direction": "ASC", "SortAttribute": "Name", "DisplayName": "Name"}],
        }],
    };
}

export default RelatableObjectTableApplet;
